(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/competition-handler/common/create-player-competition-handler-base.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/competition-handler/common/create-player-competition-handler-base.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
let logger;
let normalizePlayerCompetitions;
let normalizeTeams;
let playerCompetitionDetailStatus;
let PromiseStatus;
let settleRequestsSerially;
if (svs.isServer) {
  logger = require('../server/logger');
  normalizePlayerCompetitions = require('../../competition-helper/assets/javascripts/normalize-player-competitions.es6').normalizePlayerCompetitions;
  playerCompetitionDetailStatus = require('./constants.es6').playerCompetitionDetailStatus;
  PromiseStatus = require('../../constants/assets/javascripts/promise-status.es6').PromiseStatus;
  settleRequestsSerially = require('../../constants/assets/javascripts/settle-requests-serially.es6').settleRequestsSerially;
} else {
  logger = svs.components.marketplaceCompetition.competitionHandler.client.logger;
  normalizePlayerCompetitions = svs.components.marketplaceCompetition.competitionHelper.normalizePlayerCompetition.normalizePlayerCompetitions;
  normalizeTeams = svs.components.marketplaceCompetition.competitionHelper.normalizeTeams;
  playerCompetitionDetailStatus = svs.components.marketplaceCompetition.competitionHandler.common.constants.playerCompetitionDetailStatus;
  PromiseStatus = svs.components.marketplaceCompetition.constants.promiseStatus.PromiseStatus;
  settleRequestsSerially = svs.components.marketplaceCompetition.constants.settleRequestsSerially.settleRequestsSerially;
}
const getPaths = (competitionId, teamIds, shouldFetchIndividualResults) => {
  const resultsPaths = [];
  if (shouldFetchIndividualResults) {
    resultsPaths.push("/player/2/competitions/".concat(competitionId, "/result"));
  }
  if (teamIds) {
    teamIds.forEach(teamId => {
      resultsPaths.push("/player/2/competitions/".concat(competitionId, "/team/result?teamId=").concat(teamId));
    });
  }
  return resultsPaths;
};
const createPlayerCompetitionHandlerBase = function () {
  let privateInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let _playerCompetitionDetails = {};

  privateInterface.setPlayerCompetitionDetails = playerCompetitionDetails => {
    _playerCompetitionDetails = playerCompetitionDetails;
  };

  privateInterface.setPlayerCompetition = _ref => {
    let competitionId = _ref.competitionId;
    _playerCompetitionDetails.playerCompetitions[competitionId] = {
      competitionId,
      isDirty: true
    };
  };

  privateInterface.setPlayerCompetitionDraw = _ref2 => {
    var _playerCompetitionDet;
    let drawNumber = _ref2.drawNumber,
      competitionId = _ref2.competitionId;
    if (!((_playerCompetitionDet = _playerCompetitionDetails) !== null && _playerCompetitionDet !== void 0 && _playerCompetitionDet.playerCompetitionDraws)) {
      _playerCompetitionDetails.playerCompetitionDraws = {};
    }
    if (_playerCompetitionDetails.playerCompetitionDraws[competitionId]) {
      _playerCompetitionDetails.playerCompetitionDraws[competitionId] = [..._playerCompetitionDetails.playerCompetitionDraws[competitionId], drawNumber];
    } else {
      _playerCompetitionDetails.playerCompetitionDraws[competitionId] = [drawNumber];
    }
    _playerCompetitionDetails.playerCompetitionDraws = _objectSpread(_objectSpread({}, _playerCompetitionDetails.playerCompetitionDraws), {}, {
      isDirty: true
    });
  };

  privateInterface.deletePlayerCompetitionDraw = _ref3 => {
    var _playerCompetitionDet2;
    let drawNumber = _ref3.drawNumber,
      competitionId = _ref3.competitionId;
    if (!((_playerCompetitionDet2 = _playerCompetitionDetails) !== null && _playerCompetitionDet2 !== void 0 && _playerCompetitionDet2.playerCompetitionDraws) || !_playerCompetitionDetails.playerCompetitionDraws[competitionId]) {
      return;
    }
    if (_playerCompetitionDetails.playerCompetitionDraws[competitionId].includes(drawNumber)) {
      const playerDrawsForCompetition = [..._playerCompetitionDetails.playerCompetitionDraws[competitionId]];
      playerDrawsForCompetition.splice(playerDrawsForCompetition.indexOf(drawNumber), 1);
      _playerCompetitionDetails.playerCompetitionDraws[competitionId] = playerDrawsForCompetition;
    }

    _playerCompetitionDetails.playerCompetitionDraws = _objectSpread(_objectSpread({}, _playerCompetitionDetails.playerCompetitionDraws), {}, {
      isDirty: true
    });
  };
  privateInterface.getPlayerCompetitionDetails = () => _playerCompetitionDetails;
  return function () {
    let publicInterface = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    publicInterface.fetchPlayerCompetitions = async function () {
      let activeOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      let req = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      const response = await privateInterface.jupiter("/player/1/competitions?activeOnly=".concat(activeOnly), {
        method: 'GET'
      }, req);
      logger.debug('Fetch playerCompetitions');
      const comps = normalizePlayerCompetitions(response.competitions);
      const status = !response.error ? playerCompetitionDetailStatus.FETCHED : playerCompetitionDetailStatus.NOT_FETCHED;
      return [comps, status];
    };
    publicInterface.fetchPlayerCompetitionDraws = async (playerCompetitionIds, req) => {
      try {
        if (!(playerCompetitionIds instanceof Array) || !playerCompetitionIds.length) {
          logger.info("No ids provided for player competition draws status, ids: ".concat(playerCompetitionIds));
          return;
        }
        const paths = playerCompetitionIds.map(compId => "/player/1/competitions/".concat(compId, "/drawstatus"));
        const responses = await settleRequestsSerially(paths.map(path => () => privateInterface.jupiter(path, {
          method: 'GET'
        }, req)));
        const structurePlayerCompetitionsDraws = {};
        responses.forEach((response, index) => {
          const competitionId = playerCompetitionIds[index];
          if (response.status === PromiseStatus.Rejected) {
            var _response$reason;
            logger.warn("Failed to fetch player competition draw status for ".concat(competitionId, ": ").concat(((_response$reason = response.reason) === null || _response$reason === void 0 ? void 0 : _response$reason.message) || response.reason));
            return;
          }
          const value = response.value;

          if (value.hasOwnProperty('error')) {
            var _value$error;
            logger.warn("Failed to fetch player competition draw status for ".concat(competitionId, ": ").concat(((_value$error = value.error) === null || _value$error === void 0 ? void 0 : _value$error.message) || JSON.stringify(value.error)));
            return;
          }
          structurePlayerCompetitionsDraws[competitionId] = value.participatedDraws;
        });
        return structurePlayerCompetitionsDraws;
      } catch (err) {
        logger.warn("Error fetching player competition draws: ".concat(err === null || err === void 0 ? void 0 : err.message, " ").concat(JSON.stringify(err)));
      }
    };
    publicInterface.fetchPlayerCompetitionDetails = async function () {
      let competitionIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      let activeOnly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      let shouldFetchAllDraws = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      let req = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      let playerCompetitionDraws;
      const _await$publicInterfac = await publicInterface.fetchPlayerCompetitions(activeOnly, req),
        _await$publicInterfac2 = _slicedToArray(_await$publicInterfac, 2),
        playerCompetitions = _await$publicInterfac2[0],
        status = _await$publicInterfac2[1];
      const playerCompetitionIds = [];
      if ((competitionIds.length || shouldFetchAllDraws) && Object.values(playerCompetitions || {}).length) {
        Object.values(playerCompetitions).forEach(playerComp => {
          if (competitionIds.includes(playerComp.competitionId) || shouldFetchAllDraws) {
            playerCompetitionIds.push(playerComp.competitionId);
          }
        });
      }
      if (playerCompetitionIds.length) {
        logger.info("Fetching player competition draws for ids: ".concat(playerCompetitionIds));
        playerCompetitionDraws = await publicInterface.fetchPlayerCompetitionDraws(playerCompetitionIds, req);
      }
      return [playerCompetitions, playerCompetitionDraws, status];
    };
    publicInterface.fetchPlayerCompetitionResults = async function (competitionId, teamIds, shouldFetchIndividualResults) {
      let req = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : undefined;
      if (!competitionId) {
        return {
          responses: [undefined, undefined]
        };
      }
      const paths = getPaths(competitionId, teamIds, shouldFetchIndividualResults);
      if (!paths.length) {
        return {
          responses: []
        };
      }
      if (paths.length === 1) {
        return privateInterface.jupiter(paths[0], {
          method: 'GET'
        }, req);
      }
      const responses = await settleRequestsSerially(paths.map(path => () => privateInterface.jupiter(path, {
        method: 'GET'
      }, req)));
      return {
        responses: responses.map(response => response.status === PromiseStatus.Fulfilled ? response.value : {
          error: response.reason
        })
      };
    };
    publicInterface.fetchPlayerCompetitionTeams = async competitionId => {
      const response = await privateInterface.jupiter("/player/2/competitions/".concat(competitionId, "/teams"), {
        method: 'GET'
      });
      return {
        teams: normalizeTeams(response.teams)
      };
    };
    publicInterface.getPlayerCompetitions = () => _playerCompetitionDetails;
    publicInterface.getPlayerCompetitionDetails = () => logger.warn('getPlayerCompetitionDetails should be implemented by server / client');
    return publicInterface;
  };
};
if (svs.isServer) {
  module.exports = createPlayerCompetitionHandlerBase;
} else {
  setGlobal('svs.components.marketplaceCompetition.competitionHandler.common.createPlayerCompetitionHandlerBase', createPlayerCompetitionHandlerBase);
}

 })(window);